import React, { useEffect, useRef } from 'react';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { BlockSelectModal } from './BlockSelectModal';
import { ClickableIcon } from '@client/new/components/basic';
import { F0 } from '@client/new/helpers/types';
import { ISection } from '@playbook-technologies/common-schemas';

type Props = {
  onAdd: (o: ISection['type']) => void;
};
export function AddSection({ onAdd }: Props) {
  const [show, setShow] = React.useState(false);
  const ref = useRef<{ focus: F0 }>(null);

  useEffect(() => {
    if (show && ref.current) ref.current.focus();
  }, [show]);

  if (show) {
    return <BlockSelectModal onClose={() => setShow(false)} onSelect={onAdd} />;
  }
  return (
    <div className="text-xl w-10 h-10 bg-[#E1E5F0] rounded-lg flex items-center justify-center">
      <ClickableIcon
        icon={faPlus}
        onClick={() => setShow(true)}
        title="Add new block"
      />
    </div>
  );
}
